import { organizationData } from '@/store/helpers';
import { computed, Ref } from 'vue';
import { ItemDrawerTabName, TabOrderItem } from '@/api';

const _defaultTabOrder: { [K in ItemDrawerTabName]: TabOrderItem } = {
  [ItemDrawerTabName.DISCUSSION]: {
    tabName: ItemDrawerTabName.DISCUSSION,
    hidden: false,
  },
  [ItemDrawerTabName.SUBTASKS]: {
    tabName: ItemDrawerTabName.SUBTASKS,
    hidden: false,
  },
  [ItemDrawerTabName.CHILD_ITEMS]: {
    tabName: ItemDrawerTabName.CHILD_ITEMS,
    hidden: false,
  },
  [ItemDrawerTabName.TIME_TRACKING]: {
    tabName: ItemDrawerTabName.TIME_TRACKING,
    hidden: false,
  },
  [ItemDrawerTabName.FORMS_TAB]: {
    tabName: ItemDrawerTabName.FORMS_TAB,
    hidden: false,
  },
  [ItemDrawerTabName.ASSETS]: {
    tabName: ItemDrawerTabName.ASSETS,
    hidden: false,
  },
  [ItemDrawerTabName.GITHUB]: {
    tabName: ItemDrawerTabName.GITHUB,
    hidden: false,
  },
  [ItemDrawerTabName.ACTIVITY]: {
    tabName: ItemDrawerTabName.ACTIVITY,
    hidden: false,
  },
};
export const defaultTabOrder: TabOrderItem[] = Object.values(_defaultTabOrder);

export function useTabOrder({
  workTypeId,
}: { workTypeId?: Ref<string | undefined> } = {}) {
  const { workTypes } = organizationData();

  const tabOrder = computed<ItemDrawerTabName[]>(() => {
    const id = workTypeId?.value;
    if (id && workTypes.value?.length) {
      const workType = workTypes.value.find((o) => o.id === id);
      if (workType && workType.tabOrders?.length > 0) {
        return workType.tabOrders
          .filter((tab) => !tab.hidden)
          .map((tab) => tab.tabName);
      }
    }
    return defaultTabOrder
      .filter((tab) => !tab.hidden)
      .map((tab) => tab.tabName);
  });

  return { tabOrder };
}
